import React, {FC} from 'react';
import styled from 'styled-components';

/*
 * Props.
 */

export interface ChartLegendBadgeProps {
  color: string;
}

/*
 * Style.
 */

const SerieBadge = styled.span<{$color: string}>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${(p) => p.$color};
  margin-right: 7px;
  margin-left: 3px;
`;

/*
 * Component.
 */

export const ChartLegendBadge: FC<ChartLegendBadgeProps> = ({color}) => <SerieBadge $color={color} />;
